export const requiredFormValues = {
  pkdDiagnosis        : '',
  patientRelationship : '',
  kidneyTransplant    : '',
  monthOfBirth        : '',
  dayOfBirth          : '',
  yearOfBirth         : '',
};

export const medicalFormValues = {
  pkdDiagnosis                  : '',
  patientRelationship           : '',
  kidneyTransplant              : '',
  date_of_birth                 : '',
  communicationNewsletter       : 'true',
  communicationStudyOpportunity : 'true',
  communicationReminders        : 'true',
  hasMigratedMedicalInfo        : '',
  firstName                     : '',
  lastName                      : '',
};

export const getAttributeInfo = (attributes = [], formValues) => {
  return (
    attributes?.filter((personAttribute) =>
      Object.keys(formValues).includes(personAttribute.attribute)
    ) ?? []
  );
};

export const getMedicalInfoWithIds = (person, medicalFormValues) => {
  const medicalWithIdsRecords = {};
  getAttributeInfo(person, medicalFormValues).forEach((personAttribute) => {
    const attributes = personAttribute.data.attributes;
    medicalWithIdsRecords[attributes.name] = {
      id    : personAttribute.data.id,
      value : attributes.value,
    };
  });
  return medicalWithIdsRecords;
};

export const medicalInfoPayload = ({ person, attributes, data }) => {
  let ids = getMedicalInfoWithIds(person, medicalFormValues);
  return {
    attributes,
    relationships : {
      person_attribute : [
        {
          type       : 'person_attribute',
          ...(ids.pkdDiagnosis ? { id: ids.pkdDiagnosis.id } : {}),
          attributes : {
            attribute : 'pkdDiagnosis',
            value     : data.pkdDiagnosis,
          },
        },
        {
          type : 'person_attribute',
          ...(ids.patientRelationship
            ? { id: ids.patientRelationship.id }
            : {}),
          attributes : {
            attribute : 'patientRelationship',
            value     : data.patientRelationship,
          },
        },
        {
          type       : 'person_attribute',
          ...(ids.kidneyTransplant ? { id: ids.kidneyTransplant.id } : {}),
          attributes : {
            attribute : 'kidneyTransplant',
            value     : data.kidneyTransplant,
          },
        },
        {
          type       : 'person_attribute',
          ...(ids.date_of_birth ? { id: ids.date_of_birth.id } : {}),
          attributes : {
            attribute : 'date_of_birth',
            value     : `${data.yearOfBirth}/${data.monthOfBirth}/${data.dayOfBirth}`,
          },
        },
        {
          type : 'person_attribute',
          ...(ids.communicationReminders
            ? { id: ids.communicationReminders.id }
            : {}),
          attributes : {
            attribute : 'communicationReminders',
            value     : 'true',
          },
        },
        {
          type : 'person_attribute',
          ...(ids.communicationNewsletter
            ? { id: ids.communicationNewsletter.id }
            : {}),
          attributes : {
            attribute : 'communicationNewsletter',
            value     : 'true',
          },
        },
        {
          type : 'person_attribute',
          ...(ids.communicationStudyOpportunity
            ? { id: ids.communicationStudyOpportunity.id }
            : {}),
          attributes : {
            attribute : 'communicationStudyOpportunity',
            value     : 'true',
          },
        },
        {
          type : 'person_attribute',
          ...(ids.hasMigratedMedicalInfo
            ? { id: ids.hasMigratedMedicalInfo.id }
            : {}),
          attributes : {
            attribute : 'hasMigratedMedicalInfo',
            value     : 'yes',
          },
        },
      ],
    },
  };
};

export const getPersonMedicalRecords = (attributes = [], medicalFormValues) => {
  const medicalRecords = {};
  getAttributeInfo(attributes, medicalFormValues).forEach((personAttribute) => {
    medicalRecords[personAttribute.attribute] = personAttribute.value;
  });
  return medicalRecords;
};

export const getPersonDateOfBirth = (attributes) => {
  const dateOfBirth = getPersonMedicalRecords(
    attributes,
    medicalFormValues
  )?.date_of_birth;
  if (!dateOfBirth) {
    return {};
  }
  let yearOfBirth, monthOfBirth, dayOfBirth;
  
  if (dateOfBirth.includes('T')) {
    const date = new Date(dateOfBirth);
    yearOfBirth = date.getUTCFullYear();
    monthOfBirth = String(date.getUTCMonth() + 1).padStart(2, '0');
    dayOfBirth = String(date.getUTCDate()).padStart(2, '0');
  } else if (dateOfBirth.includes('/')) {
    const dateOfBirthSplit = dateOfBirth.split('/');
    yearOfBirth = dateOfBirthSplit[0];
    monthOfBirth = String(dateOfBirthSplit[1]).padStart(2, '0');
    dayOfBirth = String(dateOfBirthSplit[2]).padStart(2, '0');
  }

  return {
    yearOfBirth,
    monthOfBirth,
    dayOfBirth
  };
};

export const getPersonAttribute = (attributes, form) => {
  const personAttributes =
    attributes
      .filter((attributeDetails) =>
        Object.keys(form).includes(attributeDetails.attribute)
      )
      .map((attributeDetails) => ({
        [attributeDetails.attribute] : attributeDetails.value,
      })) ?? [];
  return Object.assign({}, ...personAttributes);
};

export const getAttributesPayload = (formData, attributes) => {
  const attributesArray = [];
  for (const attributeKey in formData) {
    if (
      formData[attributeKey] !== attributes[attributeKey] &&
      formData[attributeKey] !== ''
    ) {
      const value = formData[attributeKey];
      const attribute = {
        data : {
          type       : 'person-attributes',
          attributes : {
            attribute : attributeKey,
            value,
            type      : 'person',
          },
        },
      };
      if (value) {
        attributesArray.push(attribute);
      }
    }
  }
  return attributesArray;
};
